<template>
    <div class="loding">
        <el-dialog
            title="免费预约上门演示"
            :visible.sync="visible"
            class="setWidth"
            @close='close'
            center
            :close-on-press-escape='false'
            :close-on-click-modal='false'>
<!--                <div class='title'>请完善以下信息，Worktile产品将在1个工作日内与您联系</div>-->
                <div class='ttt'>姓名<span>*</span></div>
                <el-input placeholder='请输入姓名' class='inputt' v-model='name'></el-input>
                <div class='ttt'>手机号<span>*</span></div>
                <el-input placeholder='请输入手机号' class='inputt' v-model='tel'></el-input>
                <div class='ttt'>企业名称<span>*</span></div>
                <el-input placeholder='请输入企业名称' class='inputt' v-model='qy'></el-input>
                <div class='ttt'>使用人数<span>*</span></div>
                <div class='num'>
                    <div v-for='(item,index) in numList' :key='index' @click='numIndex = index' v-model='use_people' :style='{"border-color": numIndex == index ? "#1e80ff" : "", color: numIndex == index ? "#1e80ff" : ""}'>{{item}}</div>
                </div>
<!--                <div class='ttt'>选择您想要的管理工作<span>*</span></div>-->
<!--                <div class='num'>-->
<!--                    <div v-for='(item,index) in numList2' :key='index' @click='numIndex2 = index' v-model='manage_job' :style='{"border-color": numIndex2 == index ? "#1e80ff" : "", color: numIndex2 == index ? "#1e80ff" : ""}'>{{item}}</div>-->
<!--                </div>-->
                <div class='sub' @click="getFKFormInfo()">提交</div>
<!--                <div class='footer'>提交申请代表同意<span>《Worktile 服务条款》</span></div>-->
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
export function uploadAction(url,parameter){
    return axios({
        url: url,
        data: parameter,
        method:'post' ,
        headers: {
            'Content-Type': 'multipart/form-data',  // 文件上传
        },
    })
}
export default {
    name: 'loding',
    props:{
        visible: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            name: '',
            tel: '',
            qy: '',
            use_people: '',
            manage_job: '',
            numIndex: -1,
            numList: ['1-25','26-50','51-100','101-300','300以上'],
            numIndex2: -1,
            numList2: ['项目','企业/部门','产品','IT','市场','设计','运营','人事行政','个人','其他'],
        }
    },
    mounted() {

    },
    methods:{
        getFKFormInfo() {
            let url = "https://iboran.com/api.php/cms/addform"
            let params = {
                fcode: 4,
                tel: this.tel,
                manage_job: 'IT',
                use_people: '88',
                company: this.qy,
                code: '123456',
                name: this.name
            }
            uploadAction(url, params).then(res => {
                // console.log(res, 'rrrrrrrrrrrrrr-----------ssssssss')
                alert(res.data.data)
            }).catch(err => {
                alert(err.message)
            })
            // $.ajax({
            //     type: "POST",
            //     url: "http://cs.djbhwang.com/api.php/cms/addform",
            //     data: {
            //         fcode: 4,
            //         tel: this.tel,
            //         manage_job: this.manage_job,
            //         use_people: this.use_people,
            //         company: this.qy,
            //         code: '123456',
            //         name: this.name
            //     },
            //     dataType:'json',
            //     success: function (res) {
            //         alert(res.data)
            //         console.log(res, 'result-------------result')
            //     },
            //     error: function (res) {
            //         callback([]);
            //     },
            // });
        },
        close() {
            this.$emit('update:visible', false);
            console.log(213)
        }
    }
}
</script>

<style lang="scss" scoped>
    .loding{
        .title{
            text-align: center;
            color: #999;
            font-size: 12px;
            margin-bottom: 30px;
        }
        .ttt{
            font-size: 16px;
            span{
                color: #e31924;
            }
        }
        .inputt{
            margin: 20px 0;
        }
        .num{
            display: flex;
            flex-wrap: wrap;
            margin: 20px 0 10px;
            >div{
                width: 100px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border: 1px solid #999;
                margin-right: 20px;
                margin-bottom: 10px;
                cursor: pointer;
            }
        }
        .sub{
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 16px;
            background: #e6322e;
            color: #fff;
            cursor: pointer;
            margin-top: 30px;
        }
        .footer{
            font-size: 12px;
            color: #999;
            text-align: center;
            margin-top: 30px;
            >span{
                color: #1e80ff;
            }
        }
    }
</style>

<style scoped>
@media all and (min-width: 980px) {
    .setWidth{
        /*width: 700px !important;*/
    }
    /deep/ .el-dialog{
        width: 700px !important;
    }
}
@media all and (max-width: 980px) {
    .setWidth{
        /*width: 100% !important;*/
    }
    /deep/ .el-dialog{
        width: 80% !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/loding.vue